import { useAsyncAtom } from '@automation-suite/shared-utils-jotai';
import { Editor } from '@monaco-editor/react';
import { Action } from '@soluto-private/mx-asurion-ui-react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { widgetAtom } from '../storage';

const ActionButtonContainer = styled.div``;

export const ThemeConfigPreview = () => {
  const { value: widget } = useAsyncAtom(widgetAtom);
  const [themeConfig, setThemeConfig] = useState<string>('');

  useEffect(() => {
    if (!widget) {
      setThemeConfig('');
      return;
    }

    const subscription = widget.subscribe('options', (options) => {
      if (!options) {
        setThemeConfig('');
        return;
      }

      const formatted = JSON.stringify(options, null, 2);
      setThemeConfig(formatted);
    });

    return () => {
      subscription?.unsubscribe?.();
    };
  }, [widget]);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(themeConfig).catch(() => {
      console.error('Failed to copy themeConfig to clipboard');
    });
  };

  return (
    <>
      <Editor
        defaultLanguage="json"
        height="400px"
        value={themeConfig || '{}'}
        options={{
          readOnly: true,
          minimap: { enabled: false },
          wordWrap: 'on',
          wrappingIndent: 'same',
          formatOnPaste: true,
          formatOnType: false,
        }}
      />
      <ActionButtonContainer>
        <Action onClick={handleCopy}>Copy Config</Action>
      </ActionButtonContainer>
    </>
  );
};
